import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({catid, vid, setLoading}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/vendor/fetch_subcatogory.php?vid=${vid}&catid=${catid}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      }
      
    };
    if(vid){
      fetchData();
    }
  }, [catid, vid, setLoading]);

  return {data};
};

export default useFetchData;